import React, { Component } from 'react';
import { toast } from "react-toastify";
import axios from "axios";
import ApiLoader from '../common/loader';
import { REACT_APP_API_URL } from "../common/config";
import * as API_URL from "../redux/actions/webApiList";
import './violationDetails.css';

class LockImageUpload extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedFiles: [],
            description: '',
            isDragging: false,
            errors: {
                lock_image: '',
                description: ''
            },
            isUploading: false,
            previewUrls: []
        }
    }

    handleDragEnter = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.setState({ isDragging: true });
    }

    handleDragLeave = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.setState({ isDragging: false });
    }

    handleDragOver = (e) => {
        e.preventDefault();
        e.stopPropagation();
    }

    handleDrop = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.setState({ isDragging: false });

        const files = Array.from(e.dataTransfer.files).filter(file => file.type.startsWith('image/'));
        if (files.length > 0) {
            this.handleFilesSelect(files);
        }
    }

    handleFilesSelect = (files) => {
        const allowedTypes = ['image/jpeg', 'image/jpg', 'image/png', 'image/svg+xml', 'image/gif'];
        const newFiles = Array.from(files).filter(file => allowedTypes.includes(file.type));
        
        if (newFiles.length !== files.length) {
            toast.error('Only jpg, jpeg, png, svg, and gif files are allowed');
            return;
        }

        const newPreviewUrls = newFiles.map(file => window.URL.createObjectURL(file));

        this.setState(prevState => ({
            selectedFiles: [...prevState.selectedFiles, ...newFiles],
            previewUrls: [...prevState.previewUrls, ...newPreviewUrls],
            errors: {
                ...prevState.errors,
                lock_image: ''
            }
        }));
    }

    removeImage = (index) => {
        this.setState(prevState => {
            const newFiles = [...prevState.selectedFiles];
            const newPreviewUrls = [...prevState.previewUrls];

            // Revoke the object URL to prevent memory leaks
            window.URL.revokeObjectURL(newPreviewUrls[index]);

            newFiles.splice(index, 1);
            newPreviewUrls.splice(index, 1);

            return {
                selectedFiles: newFiles,
                previewUrls: newPreviewUrls
            };
        });
    }

    handleSubmit = async (e) => {
        e.preventDefault();
        const { selectedFiles, description } = this.state;
        const { violation_id } = this.props;

        let hasError = false;
        const errors = {
            lock_image: '',
            description: ''
        };

        // Validate images
        if (selectedFiles.length === 0) {
            errors.lock_image = 'Please select at least one image to upload';
            hasError = true;
        }

        // Validate description
        if (!description.trim()) {
            errors.description = 'Please enter a description';
            hasError = true;
        }

        // If there are errors, show them and stop submission
        if (hasError) {
            this.setState({ errors });
            return;
        }

        // Create FormData and append all required fields
        const formData = new FormData();
        selectedFiles.forEach((file) => {
            formData.append('lock_image[]', file);
        });
        formData.append('description', description);
        formData.append('violation_id', violation_id);
        formData.append('total_images', selectedFiles.length);

        // Set loading state
        this.setState({ isUploading: true });

        try {
            const response = await axios.post(REACT_APP_API_URL + API_URL.UPLOAD_LOCK_IMAGE, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });

            if (response.status === 200) {
                toast.success(response?.data?.message);
                // Clean up object URLs
                this.state.previewUrls.forEach(url => window.URL.revokeObjectURL(url));
                this.setState({
                    selectedFiles: [],
                    previewUrls: [],
                    description: '',
                    isDragging: false,
                    errors: {
                        lock_image: '',
                        description: ''
                    },
                    isUploading: false
                });
                // Call parent's onSuccess if provided
                if (this.props.onSuccess) {
                    this.props.onSuccess();
                }
            } else {
                toast.error(response?.data?.message);
                this.setState({ isUploading: false });
            }
        } catch (error) {
            console.error('Error uploading images:', error);
            if (error.response && error.response.data && error.response.data.error) {
                toast.error(error.response.data.error[0]);
            } else {
                toast.error('Failed to upload images. Please try again.');
            }
            this.setState({ isUploading: false });
        }
    }

    componentWillUnmount() {
        // Clean up object URLs when component unmounts
        this.state.previewUrls.forEach(url => window.URL.revokeObjectURL(url));
    }

    render() {
        return (
            <div>
                {this.state.isUploading && <ApiLoader />}
                <form onSubmit={this.handleSubmit} className="upload-form">
                    <div className='form-group'>
                        <label htmlFor="description">Lock Picture</label>
                        <div
                            className={`image-preview-container ${this.state.isDragging ? 'drag-over' : ''} ${this.state.errors.lock_image ? 'has-error' : ''}`}
                            onDragEnter={this.handleDragEnter}
                            onDragLeave={this.handleDragLeave}
                            onDragOver={this.handleDragOver}
                            onDrop={this.handleDrop}
                        >

                            <div className="preview-box">
                                <div className="preview-container">
                                    {this.state.previewUrls.map((url, index) => (
                                        <div key={index} className="preview-item">
                                            <img src={url} alt={`Preview ${index + 1}`} />
                                            <button
                                                type="button"
                                                className="remove-image"
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    this.removeImage(index);
                                                }}
                                            >
                                                <i className="fas fa-times"></i>
                                            </button>
                                        </div>
                                    ))}
                                </div>
                                <div
                                    className="upload-placeholder"
                                    id="upload-placeholder"
                                    style={{ display: this.state.previewUrls.length > 0 ? 'none' : 'block' }}
                                >
                                    <i className="fas fa-cloud-upload-alt"></i>
                                    <p>Click to browse or drag and drop your images</p>
                                </div>
                            </div>
                            <input
                                type="file"
                                id="lock-image"
                                accept="image/*"
                                multiple
                                className="file-input"
                                onChange={(e) => {
                                    const files = e.target.files;
                                    if (files.length > 0) {
                                        this.handleFilesSelect(files);
                                    }
                                }}
                            />
                        </div>
                        {this.state.errors.lock_image && (
                            <div className="error-message">{this.state.errors.lock_image}</div>
                        )}
                    </div>

                    <div className={`form-group mt-4 ${this.state.errors.description ? 'has-error' : ''}`}>
                        <label htmlFor="description">Description</label>
                        <textarea
                            id="description"
                            className="form-control"
                            rows="3"
                            placeholder="Enter a description for the lock pictures..."
                            value={this.state.description}
                            onChange={(e) => {
                                this.setState({
                                    description: e.target.value,
                                    errors: {
                                        ...this.state.errors,
                                        description: ''
                                    }
                                });
                            }}
                        ></textarea>
                        {this.state.errors.description && (
                            <div className="error-message">{this.state.errors.description}</div>
                        )}
                    </div>
                    <div className="text-left mt-4">
                        <button
                            type="submit"
                            className="btn btn-primary"
                            disabled={this.state.isUploading}
                        >
                            {this.state.isUploading ? 'Uploading...' : 'Upload Pictures'}
                        </button>
                        <button
                            type="button"
                            className="btn btn-secondary mr-2"
                            onClick={this.props.onCancel}
                            disabled={this.state.isUploading}
                        >
                            Cancel
                        </button>
                    </div>
                </form>
            </div>
        );
    }
}

export default LockImageUpload; 